/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import {
  UserDefinedFieldsService,
  type Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import ToastComponent from '../../components/toast';

const usePutUpdateUdf = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  closeConfirmModal: () => void
): UseMutationResult<
  Wealthlane_CustomerService_Dtos_UserDefinedFields_UpdateUserDefinedFieldsDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        UserDefinedFieldsService.putApiCustomerApiAppUserDefinedFieldsUserDefinedField(payload)
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          await queryClient.invalidateQueries('getUserDefinedFieldsList');
          closeModal();
          closeConfirmModal();

          toast.success(<ToastComponent label='Success' message='UDF edited.' />);
        }
      },
      onError: (err) => {
        console.log('error', err);
        closeConfirmModal();
      },
    }
  );
};

export default usePutUpdateUdf;
